import Choices from 'choices.js'

export default () => ({
  init() {
    // Get all elements for language
    const select = document.querySelectorAll('select[name="category"]')

    // Set options for each instance
    const options = {
      searchEnabled: false,
      removeItems: true,
      removeItemButton: true,
      itemSelectText: '',
    }

    // Initialize each instance
    select.forEach((element) => {
      // eslint-disable-next-line no-unused-vars
      const choices = new Choices(element, options)

      // Listener on change
      element.addEventListener(
        'change',
        // eslint-disable-next-line no-unused-vars
        (event) => {
          // Filter products
          this.filterProducts()
        },
        false
      )
    })
  },

  searchProducts() {
    // Get all DOM elements
    const products = document.querySelectorAll('[data-product]')

    // Get search value
    const searchValueProduct = document
      .querySelector('input[name="search"]')
      .value.toLowerCase()

    // Loop through each item
    products.forEach((product) => {
      const titleProduct = product.querySelector('h3').textContent.toLowerCase()

      // Show item if title include search value string
      if (titleProduct.includes(searchValueProduct) || !searchValueProduct) {
        product.classList.remove('hidden')
      } else {
        product.classList.add('hidden')
      }

      // Custom message and style if no items are visible
      this.warningMessage(product)
    })
  },

  filterProducts() {
    // Get all DOM elements
    const therapeuticAreas = this.$el.querySelectorAll(
      '[data-therapeutic-area]'
    )

    // Get selected value
    const therapeuticAreaSelected = document
      .querySelector('select[id="therapeutic_area"]')
      .value.toLowerCase()

    // Loop on each item
    therapeuticAreas.forEach((therapeuticArea) => {
      // Execyte only if a value is selected
      if (therapeuticAreaSelected) {
        // Hide all items by default
        therapeuticArea.classList.add('hidden')

        const therapeuticAreaValues = JSON.parse(
          therapeuticArea.getAttribute('data-therapeutic-area')
        )

        // Show selected item
        if (therapeuticAreaValues.includes(therapeuticAreaSelected)) {
          therapeuticArea.removeAttribute('style')
          therapeuticArea.removeAttribute('x-reveal')
          therapeuticArea.classList.remove('hidden')
        }
      } else {
        therapeuticArea.classList.remove('hidden')
      }
    })
  },

  warningMessage(element) {
    // Custom message and style if no items are visible
    const section = element.closest('section')
    const articlesVisible = section.querySelectorAll('article:not(.hidden)')

    if (articlesVisible.length === 0) {
      section.querySelector('[data-error-msg]').classList.remove('hidden')
      section.querySelector('[data-button]').classList.add('hidden')
    } else {
      section.querySelector('[data-error-msg]').classList.add('hidden')
      section.querySelector('[data-button]').classList.remove('hidden')
    }
  },

  closeDialog() {
    const { dialogProduct, dialogProductContent } = this.$refs

    // Close modal
    dialogProduct.removeAttribute('open')

    // Remove all items from list
    dialogProductContent.innerHTML = ''
  },

  openDialog() {
    const { dialogProduct } = this.$refs

    // Open modal
    dialogProduct.setAttribute('open', 'open')
  },

  constructDialog(items) {
    items.forEach((item) => {
      // Check if the browser supports the HTML template element
      // by checking the presence of the content attribute for the template element.
      if ('content' in document.createElement('template')) {
        // Prepare an item for the list
        const template = document.querySelector('#dialog')

        // Clone the line and we insert it in the list
        const clone = document.importNode(template.content, true)
        const svgContainer = clone.querySelector('.relative.z-10')

        // Set the content of the line
        const href = clone.querySelector('a')
        if(item.file !== false) {
          href.setAttribute('href', item.file)
        } else {
          href.setAttribute('href', item.external_link.url)
          href.setAttribute('target', "_blank");
          // Remplacer par l'icône de lien externe
          svgContainer.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.0789 11.8179C19.4726 11.8179 18.9674 12.3231 18.9674 12.9294V22.3021H2.69789V6.03261H12.0705C12.6768 6.03261 13.1821 5.52734 13.1821 4.92103C13.1821 4.31471 12.6768 3.80945 12.0705 3.80945H1.61158C1.00526 3.80945 0.5 4.31471 0.5 4.92103V23.3884C0.5 23.9947 1.00526 24.5 1.61158 24.5H20.0789C20.6853 24.5 21.1905 23.9947 21.1905 23.3884V12.9042C21.1905 12.2979 20.6853 11.8179 20.0789 11.8179Z" fill="currentColor"/>
            <path d="M23.3884 0.5H16.7442C16.1379 0.5 15.6326 1.00526 15.6326 1.61158C15.6326 2.21789 16.1379 2.72316 16.7442 2.72316H20.7358L9.36736 14.0916C8.93789 14.5211 8.93789 15.2284 9.36736 15.6579C9.59473 15.8853 9.87263 15.9863 10.1505 15.9863C10.4284 15.9863 10.7063 15.8853 10.9337 15.6579L22.3021 4.28947V8.28105C22.3021 8.88737 22.8074 9.39263 23.4137 9.39263C24.02 9.39263 24.5253 8.88737 24.5253 8.28105V1.61158C24.5 1.00526 23.9947 0.5 23.3884 0.5Z" fill="currentColor"/>
          </svg>
        `;
        }

        const text = clone.querySelector('span')
        text.textContent = item.title

        const { dialogProductContent } = this.$refs
        dialogProductContent.appendChild(clone)
      }
    })
  },

  prepareToDownload() {
    // Get files from attribute
    const files = JSON.parse(this.$el.getAttribute('data-files'))

    // Get files length
    const { length } = files

    if (length > 1) {
      // Prepare and construct dialog
      this.constructDialog(files)

      // Open dialog
      this.openDialog()
    } else {
      const file = files[0]

      // Force download
      this.downloadFile(file)
    }
  },

  downloadFile(item) {
    // Create link element to download file
    const link = document.createElement('a')

    if(item.file !== false) {
      // Set link attributes
      link.download = item.file
      link.href = item.file
      // Force download
      link.click()

      // Remove link element
      link.remove()
    } else {
      link.href = item.external_link.url;
      link.target = "_blank";
      link.click();
      link.remove()
    }

  },
})
